import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { SidebarProvider } from '@/components/ui/sidebar';

import { AppSidebar } from './app-sidebar';
import { useWxCopilotContext } from './wx-copilot-host/context';

export function Layout() {
  const { isPanelOpen } = useWxCopilotContext();
  const { openingSlug } = useParams();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    scrollContainerRef.current?.scrollTo({ top: 0 });
  }, [openingSlug]);

  return (
    <SidebarProvider>
      <AppSidebar />
      <div
        ref={scrollContainerRef}
        className={clsx(
          'relative flex flex-1 flex-col overflow-auto',
          isPanelOpen && 'mr-[400px]',
        )}
      >
        <Outlet />
      </div>
    </SidebarProvider>
  );
}
